// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "summary-1bqfY";
var _4 = "route-3BW69";
var _5 = "trigger-2uylr";
var _6 = "trigger__inner-1s3FY";
var _7 = "slide-1eYtZ";
export { _1 as "__esModule", _2 as "mobile", _3 as "summary", _4 as "route", _5 as "trigger", _6 as "trigger__inner", _7 as "slide" }
export default { "__esModule": _1, "mobile": _2, "summary": _3, "route": _4, "trigger": _5, "trigger__inner": _6, "slide": _7 }
